module.exports = __webpack_public_path__ + "img/19.bf6693a6.svg";